import { apiClient } from 'src/careflow/ph-core/api_client/api_client';

const workflow = 'workflow';
const coreWorkflow = 'core/workflow';
const coreChecklist = 'core/checklist';

const WorkflowManagementApi = { 
  getWorkflows: async (): Promise<any> => {
    return apiClient.get<any>(`${workflow}/`);
  },
  createWorkflow: async (data: any): Promise<any> => {
    return apiClient.post<any, any>(`${coreWorkflow}`, data);
  },
  updateWorkflow: async (code: any,data: any): Promise<any> => {
    return apiClient.put<any, any>(`${coreWorkflow}/?code=${code}`, data);
  },
  getEnums: async (): Promise<any> => {
    return apiClient.get<any>(`${coreWorkflow}/enums`);
  },
  getStages: async (workflowCode: string): Promise<any> => {
    return apiClient.get<any>(`${coreWorkflow}/${workflowCode}/stages`);
  },
  createStage: async (workflowCode: string, data: any): Promise<any> => {
    return apiClient.post<any, any>(`${coreWorkflow}/${workflowCode}/stages`, data);
  },
  updateStage: async (workflowCode: string, stageCode: string, data: any): Promise<any> => {
    return apiClient.put<any, any>(`${coreWorkflow}/${workflowCode}/stages/${stageCode}`, data);
  },
  deleteStage: async (workflowCode: string, stageCode: string) : Promise<any> => {
    return apiClient.delete(`${coreWorkflow}/${workflowCode}/stages/${stageCode}`)
  },
  getWorkflowTransitions: async (workflowCode: string) => {
    return apiClient.get<any>(`${coreWorkflow}/${workflowCode}/transitions`);
  },
  createWorkflowTransition: async (workflowCode: string, data: any): Promise<any> => {
    return apiClient.post<any, any>(`${coreWorkflow}/${workflowCode}/transitions`, data);
  },
  updateWorkflowTransition: async (workflowCode: string, transitionCode: string, data: any): Promise<any> => {
    return apiClient.put<any, any>(`${coreWorkflow}/${workflowCode}/transitions/${transitionCode}`, data);
  },
  deleteWorkflowTransition: async (workflowCode: string, transitionCode: string) : Promise<any> => {
    return apiClient.delete(`${coreWorkflow}/${workflowCode}/transitions/${transitionCode}`)
  },
  getAllChecklist: async (): Promise<any> => {
    return apiClient.get<any>(`${coreChecklist}`);
  },
  getChecklist: async (id: string): Promise<any> => {
    return apiClient.get<any>(`${coreChecklist}/${id}`);
  },
  createChecklist: async (data: any): Promise<any> => {
    return apiClient.post<any, any>(`${coreWorkflow}`, data);
  },
  updateChecklist: async (id: string, data: any): Promise<any> => {
    return apiClient.put<any, any>(`${coreWorkflow}/${id}`, data);
  },
  getItems: async (id: string): Promise<any> => {
    return apiClient.get<any>(`${coreChecklist}/${id}/items`);
  },
  createItem: async (checklistId: string, data: any): Promise<any> => {
    return apiClient.post<any, any>(`${coreChecklist}/${checklistId}/items`, data);
  },
  updateItem: async (checklistId: string, itemId: string, data: any): Promise<any> => {
    return apiClient.put<any, any>(`${coreChecklist}/${checklistId}/items/${itemId}`, data);
  },
  deleteItem: async (checklistId: string, itemId: string): Promise<any> => {
    return apiClient.delete<any, any>(`${coreChecklist}/${checklistId}/items/${itemId}`);
  },
}

export const WorkflowManagementService = {
  getWorkflows: async (): Promise<any> => {
    const workflows = await WorkflowManagementApi.getWorkflows();
    if (!workflows) return undefined;
    return workflows;
  },
  createWorkflow: async (data: any): Promise<any> => {
    const workflow = await WorkflowManagementApi.createWorkflow(data);
    if (!workflow) return undefined;
    return workflow;
  },
  updateWorkflow: async (code: any,data: any): Promise<any> => {
    const workflow = await WorkflowManagementApi.updateWorkflow(code,data);
    if (!workflow) return undefined;
    return workflow;
  },
  getEnums: async (): Promise<any> => {
    const enums = await WorkflowManagementApi.getEnums();
    if (!enums) return undefined;
    return enums;
  },
  getStages: async (workflowCode: string): Promise<any> => {
    const stages = await WorkflowManagementApi.getStages(workflowCode);
    if (!stages) return undefined;
    return stages;
  },
  createStage: async (workflowCode: string, data: any): Promise<any> => {
    const stage = await WorkflowManagementApi.createStage(workflowCode, data);
    if (!stage) return undefined;
    return stage;
  },
  updateStage: async (workflowCode: string, stageCode: string, data: any): Promise<any> => {
    const stage = await WorkflowManagementApi.updateStage(workflowCode,stageCode,data);
    if (!stage) return undefined;
    return stage;
  },
  deleteStage: async (workflowCode: string, stageCode: string) : Promise<any> => {
    const stage = await WorkflowManagementApi.deleteStage(workflowCode,stageCode);
    if (!stage) return undefined;
    return stage;
  },
  getWorkflowTransitions: async (workflowCode: string) => {
    const transitions = await WorkflowManagementApi.getWorkflowTransitions(workflowCode);
    if (!transitions) return undefined;
    return transitions;
  },
  createWorkflowTransition: async (workflowCode: string, data: any): Promise<any> => {
    const transition = await WorkflowManagementApi.createWorkflowTransition(workflowCode,data);
    if (!transition) return undefined;
    return transition;
  },
  updateWorkflowTransition: async (workflowCode: string, transitionCode: string, data: any): Promise<any> => {
    const transition = await WorkflowManagementApi.updateWorkflowTransition(workflowCode,transitionCode,data);
    if (!transition) return undefined;
    return transition;
  },
  deleteWorkflowTransition: async (workflowCode: string, transitionCode: string) : Promise<any> => {
    const transition = await WorkflowManagementApi.deleteWorkflowTransition(workflowCode,transitionCode);
    if (!transition) return undefined;
    return transition;
  },
  getAllChecklist: async (): Promise<any> => {
    const checklists = await WorkflowManagementApi.getAllChecklist();
    if (!checklists) return undefined;
    return checklists;
  },
  getChecklist: async (id: string): Promise<any> => {
    const checklist = await WorkflowManagementApi.getChecklist(id);
    if (!checklist) return undefined;
    return checklist;
  },
  createChecklist: async (data: any): Promise<any> => {
    const checklist = await WorkflowManagementApi.createChecklist(data);
    if (!checklist) return undefined;
    return checklist;
  },
  updateChecklist: async (id: string, data: any): Promise<any> => {
    const checklist = await WorkflowManagementApi.updateChecklist(id,data);
    if (!checklist) return undefined;
    return checklist;
  },
  getItems: async (id: string): Promise<any> => {
    const items = await WorkflowManagementApi.getItems(id);
    if (!items) return undefined;
    return items;
  },
  createItem: async (checklistId: string, data: any): Promise<any> => {
    const item = await WorkflowManagementApi.createItem(checklistId, data);
    if (!item) return undefined;
    return item;
  },
  updateItem: async (checklistId: string, itemId: string, data: any): Promise<any> => {
    const item = await WorkflowManagementApi.updateItem(checklistId,itemId,data);
    if (!item) return undefined;
    return item;
  },
  deleteItem: async (checklistId: string, itemId: string): Promise<any> => {
    const item = await WorkflowManagementApi.deleteItem(checklistId,itemId);
    if (!item) return undefined;
    return item;
  },
}